/* Fiches produits BOUTIQUE : petits ajouts visuels mobile (style cuure.com).
   N'intervient sur aucun comportement existant :
   - lit le variant choisi (champ cache #product-variant-id, rempli par le script d'origine)
     pour mettre a jour le bloc prix / pastilles ajoute ;
   - la barre collante ne fait que cliquer sur le vrai bouton "Commander". */
(function () {
  var root = document.getElementById('product-page-content');
  if (!root) return;

  var data = [];
  try { data = JSON.parse((document.getElementById('pc-variants') || {}).textContent || '[]'); } catch (e) {}

  function find(id) {
    for (var i = 0; i < data.length; i++) if (String(data[i].id) === String(id)) return data[i];
    return null;
  }
  function each(sel, fn) { Array.prototype.forEach.call(root.querySelectorAll(sel), fn); }

  function render() {
    var input = document.getElementById('product-variant-id');
    var v = input && find(input.value);
    if (!v) return;
    each('[data-pc-now]', function (el) { el.textContent = v.p; });
    each('[data-pc-was]', function (el) { el.textContent = v.c || ''; el.hidden = !v.c; });
    each('[data-pc-pct]', function (el) { el.textContent = '-' + v.r + '%'; el.hidden = !(v.r > 0); });
    each('[data-pc-sold]', function (el) { el.hidden = !!v.a; });
    root.classList.toggle('pc-is-sold', !v.a);
    /* epuise : on ne peut pas commander (bouton desactive + "Epuise") */
    each('.add-to-cart-btn', function (b) { b.disabled = !v.a; b.setAttribute('aria-disabled', v.a ? 'false' : 'true'); });
    each('[data-gr-cta]', function (el) { el.textContent = v.a ? 'Commander' : 'Épuisé'; });
    var sb = document.querySelector('#pc-sticky .pc-sticky__btn'); if (sb) { sb.disabled = !v.a; }
  }
  render();

  // Mobile : toutes les rubriques "Le produit en detail" fermees a l'ouverture (le clic les ouvre comme avant)
  if (window.matchMedia && window.matchMedia('(max-width: 768px)').matches) {
    each('.pd-item', function (it) {
      it.setAttribute('data-state', 'closed');
      var b = it.querySelector('.pd-item__btn');
      if (b) b.setAttribute('aria-expanded', 'false');
    });
  }
  root.addEventListener('submit', function (e) { if (root.classList.contains('pc-is-sold') && !(e.target.closest && e.target.closest('[data-gr-restock-form]'))) { e.preventDefault(); e.stopImmediatePropagation(); } }, true);
  root.addEventListener('click', function (e) { var b = e.target.closest && e.target.closest('.add-to-cart-btn'); if (b && b.disabled) { e.preventDefault(); e.stopImmediatePropagation(); } }, true);

  // description courte vide (produit sans texte) : on retire juste l'espace vide
  var sd = root.querySelector('.short-desc');
  if (sd && !sd.textContent.trim()) sd.classList.add('pc-empty');

  root.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('.variant-btn')) setTimeout(render, 0);
  });

  // Carrousel "LE BON GESTE" : carte active pleine, suivantes attenuees + pastilles
  var gt = root.querySelector('[data-pc-geste]');
  if (gt) {
    var cards = gt.querySelectorAll('.pc-geste__card');
    var gdots = root.querySelectorAll('.pc-geste__dots span');
    var gtick = false;
    var gset = function () {
      gtick = false;
      var step = cards.length > 1 ? cards[1].offsetLeft - cards[0].offsetLeft : 1;
      var idx = Math.round(gt.scrollLeft / step);
      if (gt.scrollLeft >= gt.scrollWidth - gt.clientWidth - 2) idx = cards.length - 1;
      idx = Math.max(0, Math.min(cards.length - 1, idx));
      for (var i = 0; i < cards.length; i++) {
        cards[i].classList.toggle('is-active', i === idx);
        if (gdots[i]) gdots[i].classList.toggle('is-active', i === idx);
      }
    };
    gt.addEventListener('scroll', function () { if (!gtick) { gtick = true; requestAnimationFrame(gset); } }, { passive: true });
  }

  var real = root.querySelector('.add-to-cart-btn');
  var bar = document.getElementById('pc-sticky');
  var end = document.getElementById('page-bottom-anchor');
  if (!real || !bar) return;

  bar.querySelector('.pc-sticky__btn').addEventListener('click', function () { if (!real.disabled) real.click(); });

  if (!('IntersectionObserver' in window)) return;
  var pastButton = false, beforeEnd = true;
  function update() { bar.classList.toggle('is-on', pastButton && beforeEnd); }
  new IntersectionObserver(function (entries) {
    var en = entries[0];
    pastButton = !en.isIntersecting && en.boundingClientRect.top < 0;
    update();
  }).observe(real);
  if (end) {
    new IntersectionObserver(function (entries) {
      var en = entries[0];
      beforeEnd = en.boundingClientRect.top > 0; // cachee une fois le bloc produit depasse
      update();
    }).observe(end);
  }
})();

/* Fiche produit telephone facon cuure : galerie (compteur + vignettes), quantite, stock, onglets */
(function () {
  var root = document.getElementById('product-page-content'); if (!root) return;
  var tr = root.querySelector('[data-pc-gal-track]'), cur = root.querySelector('[data-pc-gal-cur]'), th = [].slice.call(root.querySelectorAll('[data-pc-thumb]'));
  if (tr) {
    var t; tr.addEventListener('scroll', function () { clearTimeout(t); t = setTimeout(function () { var i = Math.round(tr.scrollLeft / tr.clientWidth); if (cur) cur.textContent = i + 1; th.forEach(function (b, k) { b.classList.toggle('is-on', k === i); }); var a = th[i]; if (a) a.scrollIntoView({ block: 'nearest', inline: 'nearest' }); }, 60); }, { passive: true });
    th.forEach(function (b, k) { b.addEventListener('click', function () { var x = k * tr.clientWidth; tr.scrollTo({ left: x, behavior: 'smooth' }); setTimeout(function () { if (Math.abs(tr.scrollLeft - x) > 2) tr.scrollLeft = x; }, 500); }); });
  }
  var qi = root.querySelector('[data-pc-qty-in]');
  /* quantite : jamais plus que le stock de la variante choisie ("m" dans #pc-variants) */
  function qmax() {
    try { var id = (document.getElementById('product-variant-id') || {}).value, vs = JSON.parse((document.getElementById('pc-variants') || {}).textContent || '[]');
      for (var i = 0; i < vs.length; i++) if (String(vs[i].id) === String(id)) return vs[i].m || 99; } catch (e) {}
    return 99;
  }
  function clampQty() { if (!qi) return; var m = qmax(), v = Math.max(1, Math.min(m, parseInt(qi.value, 10) || 1)); qi.value = v; qi.max = m;
    root.querySelectorAll('[data-pc-qty="1"]').forEach(function (b) { b.disabled = v >= m; b.style.opacity = v >= m ? '.35' : ''; }); }
  root.querySelectorAll('[data-pc-qty]').forEach(function (b) { b.addEventListener('click', function () { if (!qi) return; qi.value = (parseInt(qi.value, 10) || 1) + (+b.getAttribute('data-pc-qty')); clampQty(); }); });
  if (qi) { qi.addEventListener('change', clampQty); qi.addEventListener('input', function () { if ((parseInt(qi.value, 10) || 0) > qmax()) clampQty(); }); }
  document.addEventListener('click', function (e) { if (e.target.closest('.variant-btn, .variant-selectors button')) setTimeout(clampQty, 60); });
  clampQty();
  var stock = root.querySelector('[data-pc-instock]');
  if (stock) new MutationObserver(function () { stock.hidden = root.classList.contains('pc-is-sold'); }).observe(root, { attributes: true, attributeFilter: ['class'] });
  var tabs = [].slice.call(document.querySelectorAll('.pc-tabs a'));
  tabs.forEach(function (a) { a.addEventListener('click', function (e) { var el = document.querySelector(a.getAttribute('href')); if (!el) return; e.preventDefault(); tabs.forEach(function (x) { x.classList.toggle('is-on', x === a); }); window.scrollTo({ top: el.getBoundingClientRect().top + window.scrollY - 110, behavior: 'smooth' }); }); });
})();

/* Fiche produit : la couverture (photo 1) reste celle des collections, mais a l'ouverture de la fiche
   on affiche la photo la plus coloree (ambiance) si elle l'est nettement plus que la photo 1. Calcul sur les vignettes (meme domaine). */
(function () {
  var root = document.getElementById('product-page-content'); if (!root) return;
  var thumbs = [].slice.call(root.querySelectorAll('.thumb-btn'));
  if (thumbs.length < 2) return;
  function colorful(img) {
    try {
      var c = document.createElement('canvas'), n = 40; c.width = n; c.height = n;
      var x = c.getContext('2d', { willReadFrequently: true }); x.drawImage(img, 0, 0, n, n);
      var d = x.getImageData(0, 0, n, n).data, rg = [], yb = [];
      for (var i = 0; i < d.length; i += 4) { rg.push(d[i] - d[i + 1]); yb.push(0.5 * (d[i] + d[i + 1]) - d[i + 2]); }
      function ms(a) { var m = 0, s = 0; a.forEach(function (v) { m += v; }); m /= a.length; a.forEach(function (v) { s += (v - m) * (v - m); }); return [m, Math.sqrt(s / a.length)]; }
      var a = ms(rg), b = ms(yb);
      return Math.sqrt(a[1] * a[1] + b[1] * b[1]) + 0.3 * Math.sqrt(a[0] * a[0] + b[0] * b[0]);
    } catch (e) { return -1; }
  }
  function ready(img) { return new Promise(function (r) { if (img.complete && img.naturalWidth) r(); else { img.addEventListener('load', r, { once: true }); img.addEventListener('error', r, { once: true }); } }); }
  var imgs = thumbs.map(function (b) { return b.querySelector('img'); });
  Promise.all(imgs.map(ready)).then(function () {
    var sc = imgs.map(colorful), best = 0;
    sc.forEach(function (v, k) { if (v > sc[best]) best = k; });
    if (best === 0 || sc[best] < 25 || sc[best] < sc[0] * 1.6) return;
    if (!root.querySelector('.thumb-btn.active') || root.querySelector('.thumb-btn.active') === thumbs[0]) thumbs[best].click();
    var tr = root.querySelector('[data-pc-gal-track]');
    var slides = tr ? tr.children : [];
    if (tr && best < slides.length && tr.scrollLeft < 2) {
      var im = slides[best].querySelector('img'); if (im) { im.loading = 'eager'; }
      tr.scrollLeft = best * tr.clientWidth;
      var cu = root.querySelector('[data-pc-gal-cur]'); if (cu) cu.textContent = best + 1;
      [].slice.call(root.querySelectorAll('[data-pc-thumb]')).forEach(function (b, k) { b.classList.toggle('is-on', k === best); });
    }
  });
})();

/* "Voir plus" sous le titre : descend au bloc "Le produit en detail" et ouvre la Description */
document.addEventListener('click', function (e) {
  var a = e.target.closest && e.target.closest('[data-sd-more]'); if (!a) return;
  var sec = document.getElementById('product-detail'); if (!sec) return;
  e.preventDefault();
  var it = sec.querySelector('.pd-item');
  if (it && it.getAttribute('data-state') !== 'open') { var b = it.querySelector('.pd-item__btn'); if (b) b.click(); }
  setTimeout(function () {
    /* la page defile dans .page-wrapper (pas la fenetre) : on fait defiler le bon conteneur */
    var sc = sec.parentElement;
    while (sc && sc !== document.body) { var oy = getComputedStyle(sc).overflowY; if ((oy === 'auto' || oy === 'scroll') && sc.scrollHeight > sc.clientHeight + 5) break; sc = sc.parentElement; }
    var box = (sc && sc !== document.body) ? sc : null;
    var y = box ? box.scrollTop + sec.getBoundingClientRect().top - box.getBoundingClientRect().top - 110 : window.scrollY + sec.getBoundingClientRect().top - 110;
    var t = box || window, y0 = box ? box.scrollTop : window.scrollY;
    t.scrollTo({ top: y, behavior: 'smooth' });
    setTimeout(function () { var now = box ? box.scrollTop : window.scrollY; if (Math.abs(now - y0) < 2) t.scrollTo({ top: y, behavior: 'instant' }); }, 700);
  }, 30);
});

/* Me prevenir du retour en stock : ouvre le petit formulaire, envoie au relais avec la variante choisie */
(function () {
  var box = document.querySelector('[data-gr-restock]'); if (!box) return;
  var form = box.querySelector('[data-gr-restock-form]'), openB = box.querySelector('[data-gr-restock-open]'), msg = box.querySelector('[data-gr-restock-msg]');
  var RELAIS = 'https://blue-darkness-90a5.oriana-mechiche.workers.dev/alerte-stock';
  function say(t, ok) { msg.textContent = t; msg.className = 'gr-restock-msg ' + (ok ? 'is-ok' : 'is-err'); msg.hidden = false; }
  openB.addEventListener('click', function () { openB.hidden = true; form.hidden = false; var e = form.email; if (e && !e.value) e.focus(); });
  form.addEventListener('submit', function (ev) {
    ev.preventDefault();
    var email = (form.email.value || '').trim(), vid = (document.getElementById('product-variant-id') || {}).value;
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) { say('Indiquez une adresse e-mail valide.', false); return; }
    if (!form.consent.checked) { say('Cochez la case pour que l’on puisse vous écrire.', false); return; }
    var btn = form.querySelector('.gr-restock-send'); btn.disabled = true;
    fetch(RELAIS, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ email: email, variant: vid, handle: box.getAttribute('data-handle'), consent: true }) })
      .then(function (r) { return r.json().then(function (d) { return [r.status, d]; }); })
      .then(function (x) {
        var d = x[1] || {};
        if (d.status === 'ok') { say('C’est noté 🩷 Vous recevrez un e-mail dès son retour en stock.', true); form.email.disabled = true; btn.hidden = true; try { var a = JSON.parse(localStorage.getItem('gr_favoris') || '[]'); var h = box.getAttribute('data-handle'); if (a.indexOf(h) === -1) { a.unshift(h); localStorage.setItem('gr_favoris', JSON.stringify(a)); } } catch (e) {} }
        else if (d.status === 'too_many') { say('Vous avez déjà fait plusieurs demandes : réessayez un peu plus tard.', false); btn.disabled = false; }
        else { say('Oups, une erreur est survenue. Réessayez dans un instant.', false); btn.disabled = false; }
      })
      .catch(function () { say('Oups, une erreur réseau. Réessayez dans un instant.', false); btn.disabled = false; });
  });
  /* si la cliente change de couleur, on remet le formulaire a zero */
  document.addEventListener('click', function (e) { if (e.target.closest('.variant-btn, .variant-selectors button')) { msg.hidden = true; var b = form.querySelector('.gr-restock-send'); b.hidden = false; b.disabled = false; form.email.disabled = false; } });
})();
